import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=6276cb5a&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6276cb5a')) {
      api.createRecord('6276cb5a', component.options)
    } else {
      api.reload('6276cb5a', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=6276cb5a&", function () {
      api.rerender('6276cb5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CRPwDPf61KpC/JS/comp/ErrorMessage.vue"
export default component.exports